export const environment = {
  production: true,
  API_URL: "https://admin.tankerwashusa.com"
};



// WEBPACK FOOTER //
// /opt/atlassian/pipelines/agent/build/src/environments/environment.ts